import Swiper from 'swiper';
import { EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import $ from 'jquery';
import 'jquery.easing';

let timeToLoaded = 0;
let timer = setInterval(() => {
  timeToLoaded++;
}, 1000);

$(()=>{

  let swiper;

  Swiper.use([EffectFade]);

  var xhr = new XMLHttpRequest();
  xhr.open("GET", "https://studionewwork.com/temporary-site/", true);
  xhr.responseType = 'json';
  xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
          // Successful response
          // loop through the response
          var response = xhr.response;

          var html = '';
          for (var i = 0; i < response.length; i++) {
              html += `<div class="swiper-slide project">
                <div class="project-image">
                  <img src="${response[i].projects_project_image.sizes['2048x2048']}" />
                </div>
              </div>`;
          }
          document.getElementById("projects").innerHTML = html;

          const project_size = $('.project').length;
          // Initialize Swiper
          swiper = new Swiper('.swiper', {
            loop: true,
            speed: 300,
            autoplay: {
              delay: 5000,
            },
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            },
            on: {
              init: function () {
                let index = (this.realIndex + 1) + '/' + project_size;
                $('.projects-index').text(index);
              },
              slideChange: function () {
                let index = (this.realIndex + 1) + '/' + project_size;
                $('.projects-index').text(index);
              },
            },
          });
          
          $('.prev').on('click', function(){
            swiper.slidePrev();
          });

          $('.next').on('click', function(){
            swiper.slideNext();
          });

          // check if the first image is loaded
          $('.project-image:first img').on('load', function(){

            const timeout = timeToLoaded > 1 ? 500 : 1000;
            clearInterval(timer);
            setTimeout(() => {
              $('body').addClass('loaded');
            }, timeout);

          });


      } else {
          // Error response
          console.log('Error:', xhr.statusText);
      }
  };
  
  xhr.onerror = function() {
    console.log('Request failed');
  };
  
  xhr.send();

  $('.toggle-info-button').on('click', function(){
    $('.info').toggleClass('opened');
    $('body').toggleClass('info-opened');
  });

  $('.logo').on('click', function(){
    if($('body').hasClass('info-opened')){
      $('.info').removeClass('opened');
      $('body').removeClass('info-opened');
    }
  });
  
});


$(window).on('load resize', function(){
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});




// $(window).on('load', function(){

// });

